<template>
  <div>
    <!-- 查询 -->
    <elastic-compute-cloud-monitor-search
      :ecColumns="tableColumnsChecked"
    ></elastic-compute-cloud-monitor-search>
    <!-- 动态表头 -->
    <Checkbox-group
      v-model="tableColumnsChecked"
      @on-change="changeTableColumns"
    >
      <Collapse>
        <Panel name="1">
          <span style="font-size:13px;font-weight:600;">{{
            $t("alarms.common.dynamicHeader")
          }}</span>
          <template slot="content">
            <Row>
              <Col span="24">
                <Row>
                  <Col span="6">
                    <Checkbox label="accountTypeName">{{
                      $t("alarms.instance.accountType")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="accountName">{{
                      $t("alarms.instance.accountName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="instanceId">{{
                      $t("alarms.instance.instanceId")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="name">{{
                      $t("alarms.instance.instanceName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="privateIp">{{
                      $t("alarms.instance.ip")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="stateName">{{
                      $t("alarms.instance.state")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="region">{{
                      $t("alarms.instance.region")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="cpuUsageAlertRuleStatistics">{{
                      $t("alarms.instance.cpuUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="memoryUsageAlertRuleStatistics">{{
                      $t("alarms.instance.memoryUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="networkInputAlertRuleStatistics">{{
                      $t("alarms.instance.networkInput")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="diskUsageAlertRuleStatistics">{{
                      $t("alarms.instance.diskSpaceUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="networkOutputAlertRuleStatistics">{{
                      $t("alarms.instance.networkOutput")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="instanceHealthCheckAlertRuleStatistics">{{
                      $t("alarms.instance.instanceHealthCheck")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="systemHealthCheckAlertRuleStatistics">{{
                      $t("alarms.instance.systemHealthCheck")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox
                      label="instanceMaintenanceInformationAlertRuleStatistics"
                      >{{
                        $t("alarms.instance.instanceMaintenanceInformation")
                      }}</Checkbox
                    >
                  </Col>
                  <Col span="6">
                    <Checkbox
                      label="frequentLoginFailuresAlertRuleStatistics"
                      >{{
                        $t("alarms.instance.frequentLoginFailures")
                      }}</Checkbox
                    >
                  </Col>
                  <Col span="6">
                    <Checkbox label="linuxInodeUsageAlertRuleStatistics">{{
                      $t("alarms.instance.linuxInodeUsage")
                    }}</Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>
          </template>
        </Panel>
      </Collapse>
    </Checkbox-group>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableECDate"
      style="width: 100%;"
      border
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="ECDelmodal = true"
            v-hasPermission="['monitor:elasticComputeCloudMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:elasticComputeCloudMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除实例模式框 -->
    <Modal v-model="ECDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ ECInstanceId }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeEC()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableElasticComputeCloudWarning from "./TableElasticComputeCloudWarning";
import ElasticComputeCloudMonitorSearch from "./ElasticComputeCloudMonitorSearch";
let tableECVue = {};
const tableElasticComputeCloudWarning = TableElasticComputeCloudWarning;
export default {
  name: "TableElasticComputeCloud",
  components: {
    ElasticComputeCloudMonitorSearch
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      ECDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      ECInstanceId: "",
      tableColumnsChecked: [
        "accountTypeName",
        "accountName",
        "instanceId",
        "name",
        "privateIp",
        "stateName",
        "region"
      ], //动态表头
      columns: [],
      tableECDate: []
    };
  },
  created() {
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("accountName", function(val) {
      tableECVue.accountName = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("accountType", function(val) {
      tableECVue.accountType = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("instanceId", function(val) {
      tableECVue.instanceId = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("region", function(val) {
      tableECVue.region = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("instanceName", function(val) {
      tableECVue.instanceName = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("privateIp", function(val) {
      tableECVue.privateIp = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("tag", function(val) {
      tableECVue.tag = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableECVue.companyId = val;
    });
  },
  beforeCreate: function() {
    tableECVue = this;
  },
  mounted: function() {
    // tableECVue.getECData();
    tableECVue.changeTableColumns();
  },
  methods: {
    showAll: function() {
      tableECVue.getECData();
    },
    // 分页显示数据
    /****************************************************/
    getECData: function() {
      //账户列表分页
      this.$api.instance
        .pageInstance({
          companyId: tableECVue.companyId,
          accountType: tableECVue.accountType,
          accountName: tableECVue.accountName,
          instanceId: tableECVue.instanceId,
          instanceName: tableECVue.instanceName,
          privateIp: tableECVue.privateIp,
          tag: tableECVue.tag,
          region: tableECVue.region,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 0
        })
        .then(res => {
          this.tableECDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      if (tableECVue.instanceId != undefined) {
        tableECVue.instanceId = "";
      }
      this.current = current;
      tableECVue.getECData();
    },
    changeSize: function(pageSize) {
      if (tableECVue.instanceId != undefined) {
        tableECVue.instanceId = "";
      }
      this.pageSize = pageSize;
      tableECVue.getECData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("instanceIdSearchName");
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.ECInstanceId = this.tableECDate[index].instanceId;
    },
    removeEC: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.instance
        .deleteInstance("id", this.tableECDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableECVue.getECData();
            this.isDisable = false;
            this.modal_loading = false;
            this.ECDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    /************************* 动态表头 *******************************/

    //动态表头
    getColumns() {
      const tableColumnList = {
        accountTypeName: {
          title: this.$t("alarms.instance.accountType"),
          fixed: "left",
          width: 120,
          key: "accountTypeName"
        },
        accountName: {
          title: this.$t("alarms.instance.accountName"),
          width: 150,
          key: "accountName"
        },
        instanceId: {
          title: this.$t("alarms.instance.instanceId"),
          width: 150,
          key: "instanceId"
        },
        name: {
          title: this.$t("alarms.instance.instanceName"),
          width: 150,
          key: "name"
        },
        privateIp: {
          title: this.$t("alarms.instance.ip"),
          width: 150,
          key: "privateIp"
        },
        cpuUsageAlertRuleStatistics: {
          title: this.$t("alarms.instance.cpuUsage"),
          width: 150,
          key: "cpuUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.cpuUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.cpuUsageAlertRuleStatistics
            );
          }
        },
        memoryUsageAlertRuleStatistics: {
          title: this.$t("alarms.instance.memoryUsage"),
          width: 150,
          key: "memoryUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.memoryUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.memoryUsageAlertRuleStatistics
            );
          }
        },
        networkInputAlertRuleStatistics: {
          title: this.$t("alarms.instance.networkInput"),
          width: 150,
          key: "networkInputAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.networkInputMonitorIndex
                    );
                  }
                }
              },
              params.row.networkInputAlertRuleStatistics
            );
          }
        },
        diskUsageAlertRuleStatistics: {
          title: this.$t("alarms.instance.diskSpaceUsage"),
          width: 150,
          key: "diskUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.diskUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.diskUsageAlertRuleStatistics
            );
          }
        },
        networkOutputAlertRuleStatistics: {
          title: this.$t("alarms.instance.networkOutput"),
          width: 150,
          key: "networkOutputAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.networkOutputMonitorIndex
                    );
                  }
                }
              },
              params.row.networkOutputAlertRuleStatistics
            );
          }
        },
        instanceHealthCheckAlertRuleStatistics: {
          title: this.$t("alarms.instance.instanceHealthCheck"),
          width: 150,
          key: "instanceHealthCheckAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.instanceHealthCheckMonitorIndex
                    );
                  }
                }
              },
              params.row.instanceHealthCheckAlertRuleStatistics
            );
          }
        },
        systemHealthCheckAlertRuleStatistics: {
          title: this.$t("alarms.instance.systemHealthCheck"),
          width: 150,
          key: "systemHealthCheckAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.systemHealthCheckMonitorIndex
                    );
                  }
                }
              },
              params.row.systemHealthCheckAlertRuleStatistics
            );
          }
        },
        instanceMaintenanceInformationAlertRuleStatistics: {
          title: this.$t("alarms.instance.instanceMaintenanceInformation"),
          width: 150,
          key: "instanceMaintenanceInformationAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.instanceMaintenanceInformationMonitorIndex
                    );
                  }
                }
              },
              params.row.instanceMaintenanceInformationAlertRuleStatistics
            );
          }
        },
        frequentLoginFailuresAlertRuleStatistics: {
          title: this.$t("alarms.instance.frequentLoginFailures"),
          width: 150,
          key: "frequentLoginFailuresAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.frequentLoginFailuresMonitorIndex
                    );
                  }
                }
              },
              params.row.frequentLoginFailuresAlertRuleStatistics
            );
          }
        },
        linuxInodeUsageAlertRuleStatistics: {
          title: this.$t("alarms.instance.linuxInodeUsage"),
          width: 150,
          key: "linuxInodeUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.linuxInodeUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.linuxInodeUsageAlertRuleStatistics
            );
          }
        },
        stateName: {
          title: this.$t("alarms.instance.state"),
          width: 150,
          key: "stateName"
        },
        region: {
          title: this.$t("alarms.instance.region"),
          width: 150,
          key: "region"
        },
        action: {
          title: this.$t("common.operation"),
          fixed: "right",
          width: 150,
          slot: "delete"
        }
      };
      let data = [tableColumnList.action];
      this.tableColumnsChecked.forEach(col => data.push(tableColumnList[col]));
      return data;
    },
    changeTableColumns() {
      this.columns = this.getColumns();
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/elasticComputeCloudDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          instanceId: row.instanceId,
          region: row.region,
          privateIp: row.privateIp,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/TableElasticComputeCloud.vue